
import Headroom from 'headroom.js';

(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.page_header = {
    attach: function (context, settings) {

    }
  };

  $(document).ready(function(){
    // headroom logics
    const header = document.querySelector('.page_header');
    header && new Headroom(header, {
      offset: $(window).height(),
    }).init();
  })

})(jQuery, Drupal);
